import { render, staticRenderFns } from "./CallLog.vue?vue&type=template&id=1a2ae1c8&"
import script from "./CallLog.vue?vue&type=script&lang=ts&"
export * from "./CallLog.vue?vue&type=script&lang=ts&"
import style0 from "./CallLog.vue?vue&type=style&index=0&id=1a2ae1c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports